export type FinanceDateLike =
  | string
  | number
  | null
  | undefined
  | {
      date?: string
      timezone_type?: number
      timezone?: string
    }

const toDisplayString = (value: string): string => {
  const trimmed = value.trim()
  if (!trimmed) return '--'
  if (/^\d{4}-\d{2}-\d{2} /.test(trimmed)) {
    return trimmed.slice(0, 10)
  }
  return trimmed
}

export const formatFinanceDate = (value: FinanceDateLike): string => {
  if (value === null || value === undefined) return '--'
  if (typeof value === 'string') return toDisplayString(value)
  if (typeof value === 'number') return String(value)
  if (typeof value === 'object') {
    if (typeof value.date === 'string') {
      return toDisplayString(value.date)
    }
    return '--'
  }
  return '--'
}

export default formatFinanceDate
